import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Layout } from "@/components/Layout";
import { ChevronRight } from "lucide-react";

export default function ParentChildren() {
    const [children, setChildren] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/parent/children").then((r) => setChildren(r.data)).finally(() => setLoading(false));
    }, []);

    return (
        <Layout>
            <div className="mb-10">
                <div className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-3">Fëmijët e mi</div>
                <h1 className="font-heading text-5xl font-black text-slate-900 tracking-tight">Zgjidhni një fëmijë</h1>
                <p className="mt-3 text-slate-600 max-w-2xl">Shihni notat, mungesat dhe aktivitetin për secilin fëmijë.</p>
            </div>

            {loading ? (
                <div className="text-slate-500">Duke ngarkuar…</div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {children.map((c) => (
                        <Link
                            key={c.id}
                            to={`/parent/student/${c.id}`}
                            className="group bg-white rounded-2xl border border-slate-200 p-6 hover:border-oxford hover:shadow-lg transition-all"
                            data-testid={`parent-child-card-${c.id}`}
                        >
                            <div className="flex items-start justify-between">
                                <div className="w-14 h-14 rounded-2xl bg-oxford text-white flex items-center justify-center font-heading text-xl font-bold">
                                    {c.name.split(" ").map((n) => n[0]).slice(0, 2).join("")}
                                </div>
                                <ChevronRight className="w-5 h-5 text-slate-400 group-hover:text-oxford group-hover:translate-x-1 transition" />
                            </div>
                            <div className="mt-5">
                                <div className="text-xs uppercase tracking-widest text-slate-500">Nxënës</div>
                                <div className="font-heading text-2xl font-bold text-slate-900 mt-1">{c.name}</div>
                                <div className="text-sm text-slate-600 mt-1">Viti {c.year}</div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </Layout>
    );
}
